import { Box, Slider } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import "./MobileScreenFilter.css";
import PlacesAutocomplete from "react-places-autocomplete";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// let noOfElements =;

const PriceSlider = styled(Slider)(({ theme }) => ({
  color: "#404040",
  height: "5px",
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 10,
    width: 10,
    backgroundColor: "#4C3CA6",

    "&:hover": {
      boxShadow: "0 0 0 3px rgba(58, 133, 137, 0.16)",
    },
    "& .airbnb-bar": {
      height: 9,
      width: 1,
      backgroundColor: "red",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 12,
    fontWeight: "normal",
    top: 35,
    backgroundColor: "unset",
    color: theme.palette.text.primary,
    "&:before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: theme.palette.mode === "dark" ? "#fff" : "#000",
    },
  },
  "& .MuiSlider-track": {
    height: 6,
  },
  "& .MuiSlider-rail": {
    color: theme.palette.mode === "dark" ? "#bfbfbf" : "#d8d8d8",
    opacity: theme.palette.mode === "dark" ? undefined : 1,
    height: 5,
  },
}));

export const MobileScreenFilter = ({
  setToggleFilters,
  toggleFilters,
  FiltersParams,
  setFiltersParams,
  defaultFilters,
}) => {
  const {
    PriceRange,
    PropertySize,
    PropertyType,
    PropertySubType,
    Purpose,
    City,
    Confirmation,
    LandUnit,
    Bedrooms,
    Bathrooms,
  } = FiltersParams;
  const [Cities, setCities] = useState([]);
  const [priceMax, setPriceMax] = useState(1000000000000000000);
  const [priceMin, setPriceMin] = useState(0);
  const [sizeIncr, setSizeIncr] = useState(0);
  const [priceModel, setPriceModel] = useState(false);
  const [sizeModel, setSizeModel] = useState(false);
  const [filterModel, setFilterModel] = useState(false);

  const setPriceRange = (e) =>
    setFiltersParams({ ...FiltersParams, PriceRange: e });

  const [sizeMax, setSizeMax] = useState(30);
  const [sizeMin, setSizeMin] = useState(0);
  const [sizeMaxTop, setSizeMaxTop] = useState(30);
  useEffect(() => {
    PropertySize[0] = sizeMin;
    PropertySize[1] = sizeMax;
    setFiltersParams({ ...FiltersParams, PropertySize: PropertySize });
  }, [sizeMax, sizeMin]);
  const resetPriceMethod = () => {
    setPriceMax(1000000000000000000);
    setPriceMin(0);
  };

  const resetFilters = () => {
    //window.location.reload();
    resetSizeMethod();
    resetPriceMethod();

    setFiltersParams({ ...defaultFilters });

    // setFiltersParams({ ...defaultFilters, City: "*" });
    // setFiltersParams({ ...defaultFilters, Bathrooms:"*" });
    // setFiltersParams({ ...defaultFilters, Bedrooms: "*" });
    // setFiltersParams({ ...defaultFilters, Confirmation: "*" });
    // setFiltersParams({ ...defaultFilters, LandUnit: "*" });
  };
  useEffect(() => {
    PropertySize[0] = sizeMin;
    PropertySize[1] = sizeMax;
    setFiltersParams({ ...FiltersParams, PropertySize: PropertySize });
  }, [sizeMax, sizeMin]);
  useEffect(() => {
    setSizeMax(
      LandUnit === "Square Feets"
        ? 8000
        : LandUnit === "Square Yards"
        ? 1000
        : LandUnit === "Square Meters"
        ? 1000
        : 30
    );
    setSizeIncr(
      LandUnit === "Square Feets"
        ? 1000
        : LandUnit === "Square Yards"
        ? 50
        : LandUnit === "Square Meters"
        ? 100
        : 2
    );

    setSizeMaxTop(
      LandUnit === "Square Feets"
        ? 8000
        : LandUnit === "Square Yards"
        ? 1000
        : LandUnit === "Square Meters"
        ? 1000
        : 30
    );
    PropertySize[1] = sizeMax;
    // setSizeMaxTop(sizeMax);
  }, [LandUnit]);
  //LandUnit
  const resetSizeMethod = () => {
    setSizeMax(sizeMaxTop);
    setSizeMin(0);
  };
  const handleSelect = async (value) => {
    var valueArr = value.split(",");

    setCity(valueArr[valueArr.length - 2]);
  };
  const setPropertySize = (e) =>
    setFiltersParams({ ...FiltersParams, PropertySize: e });
  const setPropertyType = (e) =>
    setFiltersParams({ ...FiltersParams, PropertyType: e });

  const setPropertySubType = (e) =>
    setFiltersParams({ ...FiltersParams, PropertySubType: e });
  const setPurpose = (e) => setFiltersParams({ ...FiltersParams, Purpose: e });
  const setCity = (e) => setFiltersParams({ ...FiltersParams, City: e });
  const setBathrooms = (e) =>
    setFiltersParams({ ...FiltersParams, Bathrooms: e });
  const setBedrooms = (e) =>
    setFiltersParams({ ...FiltersParams, Bedrooms: e });
  const setConfirmation = (e) =>
    setFiltersParams({ ...FiltersParams, Confirmation: e });
  const setLandUnit = (e) =>
    setFiltersParams({ ...FiltersParams, LandUnit: e });

  const handleChangePropertyType = (e) =>
    setFiltersParams({
      ...FiltersParams,
      PropertyType: e,
      PropertySubType: "*",
    });

  const handleChangeAll = (e) =>
    setFiltersParams({
      ...FiltersParams,
      PropertyType: e,
      Bathrooms: e,
      Confirmation: e,
      Purpose: e,
    });

  // const [priceRange, setPriceRange] = useState([]);
  const [noOfElements, setNoOfElements] = useState([
    { value: "1", label: "1", clicked: false },
    { value: "2", label: "2", clicked: false },
    { value: "3", label: "3", clicked: false },
    { value: "4", label: "4", clicked: false },
    { value: "5", label: "5", clicked: true },
    { value: "6", label: "6", clicked: false },
    { value: "*", label: "any", clicked: false },
  ]);

  const [noOfSelectedBeds, setNoOfSelectedBeds] = useState([
    { value: "1", label: "1", clicked: false },
    { value: "2", label: "2", clicked: false },
    { value: "3", label: "3", clicked: false },
    { value: "4", label: "4", clicked: false },
    { value: "5", label: "5", clicked: true },
    { value: "6", label: "6", clicked: false },
    { value: "*", label: "any", clicked: false },
  ]);
  //  Change the number of selected bathrooms

  //Change Bathroom Filter
  const changeNoOfSelectedBathrooms = (i) => {
    //Array Index, setNoOfElements
    let refToNoOfElements = [...noOfElements];
    refToNoOfElements.map((item, ind) => {
      if (ind == i) {
        setBedrooms(item.value);
        item.clicked = true;
      } else {
        item.clicked = false;
      }
    });
    setNoOfElements([...refToNoOfElements]);
  };
  //  Change the number of selected bedrooms

  const changeNoOfSelectedBedRooms = (i) => {
    let refToNoOfElements = [...noOfSelectedBeds];
    refToNoOfElements.map((item, ind) => {
      if (ind == i) {
        setBedrooms(item.value);
        item.clicked = true;
      } else {
        item.clicked = false;
      }
    });
    setNoOfSelectedBeds([...refToNoOfElements]);
  };

  //Change Price
  const marks = [
    {
      value: 0,
    },
    {
      value: 20,
    },
    {
      value: 500000,
    },
    {
      value: 1000000,
    },
  ];

  //Change Size
  const markSize = [
    {
      value: 0,
    },
    {
      value: 20,
    },
    {
      value: 500000,
    },
    {
      value: 1000000,
      label: "any",
    },
  ];
  function valuetext(value) {
    return `${value}°C`;
  }

  return (
    <div className="filters-modal-container">
      {/* filter close button */}

      <div className="filter-header">
        <span className="custom-heading">Filters</span>
          <div>
          <button className="filters-reset-button" onClick={() =>   setToggleFilters(false)}>
          <CloseRoundedIcon/>
        </button>
        <button className="filters-reset-button" onClick={() => resetFilters()}>
          <RestartAltIcon/>
        </button>
        <button className="filters-reset-button" onClick={() =>   setToggleFilters(false)}>
          <CheckRoundedIcon/>
        </button>
          </div>
      </div>
      <div className="filter-search-bar-container filter-title-container">
        <label>City</label>

        <PlacesAutocomplete
          value={City === "*" ? "All" : City}
          onChange={setCity}
          onSelect={handleSelect}
          searchOptions={{
            types: ["(cities)"],
            componentRestrictions: { country: "pk" },
          }}
          className="loc-auto-complete-city auto-compelete-height-34"
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <div>
              <input
                className="loc-auto-complete-city auto-compelete-height-34"
                {...getInputProps({ placeholder: "City" })}
              />

              <div>
                {loading ? (
                  <div className="loc-auto-complete-content">loading...</div>
                ) : null}

                {suggestions.map((suggestion) => {
                  const style = {
                    backgroundColor: suggestion.active ? "#c9c2e4" : "#fff",
                  };

                  return (
                    <div
                      className="loc-auto-complete-content"
                      {...getSuggestionItemProps(suggestion, { style })}
                    >
                      {suggestion.description}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
      <div className="filter-property-type-container filter-title-container">
        <label className="property-type">Type</label>
        <div className="select-property-type-button-container">
          <button
            className={` ${
              PropertyType === "*" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => handleChangePropertyType("*")}
          >
            All
          </button>
          <button
            className={` ${
              PropertyType === "Commercial"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => handleChangePropertyType("Commercial")}
          >
            Home
          </button>
          <button
            className={` ${
              PropertyType === "Plot"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => handleChangePropertyType("Plot")}
          >
            Plot
          </button>
          <button
            className={` ${
              PropertyType === "Home"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => handleChangePropertyType("Home")}
          >
            Commercial
          </button>
        </div>
      </div>
      {PropertyType !== "*" && (
        <div className="filter-property-type-container filter-title-container">
          <label className="property-type">Property Sub Type</label>
          {PropertyType === "Home" ? (
            <div className="select-property-type-button-container">
              <button
                className={` ${
                  PropertySubType === "*"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("*")}
              >
                All
              </button>
              <button
                className={` ${
                  PropertySubType === "House"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("House")}
              >
                House
              </button>
              <button
                className={` ${
                  PropertySubType === "Flat"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Flat")}
              >
                Flat
              </button>
              <button
                className={` ${
                  PropertySubType === "Upper Portion"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Upper Portion")}
              >
                Upper Portion
              </button>
              <button
                className={` ${
                  PropertySubType === "Lower Portion"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Lower Portion")}
              >
                Lower Portion
              </button>
              <button
                className={` ${
                  PropertySubType === "Farm House"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Farm House")}
              >
                Farm House
              </button>
              <button
                className={` ${
                  PropertySubType === "Room"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Room")}
              >
                Room
              </button>
              <button
                className={` ${
                  PropertySubType === "Pent House"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Pent House")}
              >
                Pent House
              </button>
            </div>
          ) : PropertyType === "Plot" ? (
            <div className="select-property-type-button-container">
              <button
                className={` ${
                  PropertySubType === "*"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("*")}
              >
                All
              </button>
              <button
                className={` ${
                  PropertySubType === "Residential Plot"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Residential Plot")}
              >
                Residential Plot
              </button>
              <button
                className={` ${
                  PropertySubType === "Commercial Plot"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Commercial Plot")}
              >
                Commercial Plot
              </button>
              <button
                className={` ${
                  PropertySubType === "Agriculture Plot"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Agriculture Plot")}
              >
                Agriculture Plot
              </button>{" "}
              <button
                className={` ${
                  PropertySubType === "Industrial Plot"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Industrial Plot")}
              >
                Industrial Plot
              </button>{" "}
            </div>
          ) : PropertyType === "Commercial" ? (
            <div className="select-property-type-button-container">
              <button
                className={` ${
                  PropertySubType === "*"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("*")}
              >
                All
              </button>
              <button
                className={` ${
                  PropertySubType === "Office"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Office")}
              >
                Office
              </button>
              <button
                className={` ${
                  PropertySubType === "Warehouse"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Warehouse")}
              >
                Warehouse
              </button>
              <button
                className={` ${
                  PropertySubType === "Building"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Building")}
              >
                Building
              </button>
              <button
                className={` ${
                  PropertySubType === "Other"
                    ? "active-filter-button"
                    : "filters-button"
                }`}
                onClick={() => setPropertySubType("Other")}
              >
                Other
              </button>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      )}

      <div className="price-slider-container filter-title-container">
        <label>Price(PKR)</label>
        <Box
          sx={{
            width: 234,
            height: 5,

            marginTop: -2,
            paddingLeft: 1,
          }}
        >
          {/* <Slider
                 aria-labelledby="range-slider"
                 getAriaValueText={valuetext}
                 defaultValue={[20, 37]}
                 onChange={(e) => {
                      console.log(e.target.value);
                   setPriceRange([...e.target.value]);
                 }}
                 valueLabelDisplay="on"
                 color
               /> */}

          <PriceSlider
            getAriaLabel={(index) =>
              index === 0 ? "Minimum price" : "Maximum price"
            }
            defaultValue={[0, 1000000]}
            valueLabelDisplay="on"
            disableSwap
            max={1000000}
            marks={marks}
            onChange={(e) => {
              setFiltersParams({
                ...FiltersParams,
                PriceRange: e.target.value,
              });
            }}
          />
        </Box>
      </div>
      <div className="filter-property-type-container mt-5 filter-title-container">
        <label className="property-type">Purpose</label>
        <div className="select-property-type-button-container">
          <button
            className={` ${
              Purpose === "*" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setPurpose("*")}
          >
            Any{" "}
          </button>
          <button
            className={` ${
              Purpose === "rent" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setPurpose("rent")}
          >
            Rent
          </button>
          <button
            className={` ${
              Purpose === "sale" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setPurpose("sale")}
          >
            Sale
          </button>
        </div>
      </div>
      <div className="filter-property-type-container  filter-title-container">
        <label className="property-type">Confirmation</label>
        <div className="select-property-type-button-container">
          <button
            className={` ${
              Confirmation === "*" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setConfirmation("*")}
          >
            Any{" "}
          </button>
          <button
            className={` ${
              Confirmation === "confirmed"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => setConfirmation("confirmed")}
          >
            Confirmed
          </button>
          <button
            className={` ${
              Confirmation === "not-confirmed"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => setConfirmation("not-confirmed")}
          >
            Not Confirmed
          </button>
        </div>
      </div>
      <div className="filter-property-type-container filter-title-container">
        <label className="property-type">Bedrooms</label>
        <div className="bedrooms-select-container">
          {noOfElements.map((item, i) => {
            return (
              <>
                <div className="bedrooms-select-element">
                  {item.clicked ? (
                    <div
                      className="dot-select-active"
                      //   onClick={() => {
                      //     console.log("hamd");
                      //   }}
                    ></div>
                  ) : (
                    <div
                      className="dot-select"
                      onClick={() => {
                        changeNoOfSelectedBathrooms(i);
                      }}
                    ></div>
                  )}

                  <label>{item.label}</label>
                </div>
                {i + 1 == noOfElements.length ? (
                  ""
                ) : (
                  <div className="straight-line"></div>
                )}
              </>
            );
          })}
        </div>
      </div>
      <div className="filter-property-type-container  filter-title-container">
        <label className="property-type">Bathrooms</label>
        <div className="bedrooms-select-container">
          {noOfSelectedBeds.map((item, i) => {
            return (
              <>
                <div className="bedrooms-select-element">
                  {item.clicked ? (
                    <div
                      className="dot-select-active"
                      //   onClick={() => {
                      //     console.log("hamd");
                      //   }}
                    ></div>
                  ) : (
                    <div
                      className="dot-select"
                      onClick={() => {
                        changeNoOfSelectedBedRooms(i);
                      }}
                    ></div>
                  )}
                  <label>{item.label}</label>
                </div>
                {i + 1 == noOfSelectedBeds.length ? (
                  ""
                ) : (
                  <div className="straight-line "></div>
                )}
              </>
            );
          })}
        </div>
      </div>
      <div className="filter-property-type-container filter-title-container">
        <label className="property-type">Land Unit</label>
        <div className="select-property-type-button-container">
          <button
            className={` ${
              LandUnit === "*" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setLandUnit("*")}
          >
            All
          </button>
          <button
            className={` ${
              LandUnit === "Square Feets"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => setLandUnit("Square Feets")}
          >
            Sq/Fts
          </button>
          <button
            className={` ${
              LandUnit === "Square Yards"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => setLandUnit("Square Yards")}
          >
            Sq/Yds
          </button>
          <button
            className={` ${
              LandUnit === "Square Meters"
                ? "active-filter-button"
                : "filters-button"
            }`}
            onClick={() => setLandUnit("Square Meters")}
          >
            Sq/Mtrs
          </button>
          <br />
          <button
            className={` ${
              LandUnit === "Marla" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setLandUnit("Marla")}
          >
            Marla
          </button>
          <button
            className={` ${
              LandUnit === "Kanal" ? "active-filter-button" : "filters-button"
            }`}
            onClick={() => setLandUnit("Kanal")}
          >
            Kanal
          </button>
        </div>
      </div>
      <div>
        {LandUnit !== "*" ? (
          <div className="price-slider-container filter-title-container">
            <label>
              Size
            </label>
            <Box
              sx={{
                width: 234,
                height: 5,

                marginTop: -2,
                paddingLeft: 1,
              }}
            >
              {/* <Slider
                 aria-labelledby="range-slider"
                 getAriaValueText={valuetext}
                 defaultValue={[20, 37]}
                 onChange={(e) => {
                      console.log(e.target.value);
                   setPriceRange([...e.target.value]);
                 }}
                 valueLabelDisplay="on"
                 color
               /> */}

              <PriceSlider
                getAriaLabel={(index) =>
                  index === 0 ? "Minimum Size" : "Maximum Size"
                }
                defaultValue={LandUnit !== "Square Feets" ? [0, 80] : [0, 1000]}
                valueLabelDisplay="on"
                disableSwap
                max={LandUnit !== "Square Feets" ? 100 : 9000}
                marks={markSize}
                onChange={(e) => {
                  setFiltersParams({
                    ...FiltersParams,
                    PropertyType: e.target.value,
                  });
                }}
              />
            </Box>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};
